module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "control pagination-centered"
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": "logo"
    }
  }), _vm._v(" "), (_vm.message) ? _c('article', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v("Aviso")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.message = false
      }
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control has-icon has-icon-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doc),
      expression: "doc"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Numero do documento",
      "required": ""
    },
    domProps: {
      "value": (_vm.doc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doc = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "disabled": !_vm.doc
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("Entrar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v("Seu usuario não esta cadastrado neste evento.")]), _vm._v(" "), _c('p', [_vm._v("Favor entrar em contato com o nosso suporte através do email "), _c('a', {
    attrs: {
      "href": "mailto:alunos@formuladelancamento.com.br"
    }
  }, [_vm._v("alunos@formuladelancamento.com.br")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#f0a939"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f565fa2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 103
// module chunks = 2